// extracted by mini-css-extract-plugin
module.exports = {"header":"TabHeader_header__1xW_5","title":"TabHeader_title__VJrYU","actions":"TabHeader_actions__1SezR"};